import React, { useState, useEffect } from "react";

const PageTitle = ({ title }) => {
  useEffect(() => {
    return () => {};
  }, [title]);

  return (
    <span className="h6">
      {title}
  </span>
  );
};

export default PageTitle;
